import {useIntl} from 'react-intl'
import {MenuItem} from './MenuItem'
import {MenuInnerWithSub} from './MenuInnerWithSub'
import {MegaMenu} from './MegaMenu'
import {useAuth, hasPermission, ADMIN_MENU_PERMS} from '../../../../../app/modules/auth'

// fds-v2 FastAPI app origin (includes the V2_PREFIX when the backend runs with one)
const V2_APP_URL = process.env.REACT_APP_API_URL

export function MenuInner() {
  const intl = useIntl()
  const {currentUser} = useAuth()
  // Per-item permission gates, mirroring the fds-v2 header menu
  // (header_menu.html). Announcements management is FDS-operator-only there —
  // no permission key expresses it, hence the profile's is_fds_admin flag.
  const canViewUsers = hasPermission(currentUser, ADMIN_MENU_PERMS.users)
  const canViewHierarchy = hasPermission(currentUser, ADMIN_MENU_PERMS.hierarchy)
  const canViewCommentary = hasPermission(currentUser, ADMIN_MENU_PERMS.commentary)
  const canViewHoursOfOperation = hasPermission(currentUser, ADMIN_MENU_PERMS.hoursOfOperation)
  const canViewCalendarEvents = hasPermission(currentUser, ADMIN_MENU_PERMS.calendarEvents)
  const isFdsAdmin = currentUser?.is_fds_admin === true
  const showAdminMenu =
    canViewUsers ||
    canViewHierarchy ||
    canViewCommentary ||
    canViewHoursOfOperation ||
    canViewCalendarEvents ||
    isFdsAdmin

  return (
    <>
      <MenuInnerWithSub
        isMega={true}
        title={intl.formatMessage({id: 'MENU.MODULES'})}
        to='/mega-menu'
        menuPlacement='bottom-start'
        menuTrigger='click'
        hasArrow={true}
      >
        <MegaMenu />
      </MenuInnerWithSub>
      <MenuItem
        title={intl.formatMessage({id: 'MENU.DASHBOARDS'})}
        to={V2_APP_URL + '/dashboards'}
      />
      {showAdminMenu && (
        <MenuInnerWithSub
          title={intl.formatMessage({id: 'MENU.ADMIN'})}
          to='/crafted'
          menuPlacement='bottom-start'
          menuTrigger='click'
          hasArrow={true}
        >
          {canViewUsers && (
            <MenuItem
              to={V2_APP_URL + '/users/manage-users'}
              fontIcon='bi-person-fill'
              title={intl.formatMessage({id: 'MENU.USERS'})}
            />
          )}
          {canViewHierarchy && (
            <MenuItem
              to={V2_APP_URL + '/locations/manage-hierarchy'}
              fontIcon='bi-send-fill'
              title={intl.formatMessage({id: 'MENU.LOCATIONS'})}
            />
          )}
          {isFdsAdmin && (
            <MenuItem
              to={V2_APP_URL + '/announcements/manage'}
              fontIcon='bi-envelope-fill'
              title={intl.formatMessage({id: 'MENU.INTERNAL_ANNOUNCEMENTS'})}
            />
          )}
          {canViewCommentary && (
            <MenuItem
              to={V2_APP_URL + '/commentary/commentaries'}
              fontIcon='bi-journal-text'
              title={intl.formatMessage({id: 'MENU.COMMENTARY'})}
            />
          )}
          {canViewHoursOfOperation && (
            <MenuItem
              to={V2_APP_URL + '/labor/hours-of-operation'}
              fontIcon='bi-clock-fill'
              title={intl.formatMessage({id: 'MENU.HOURS_OF_OPERATION'})}
            />
          )}
          {canViewCalendarEvents && (
            <MenuItem
              to={V2_APP_URL + '/calendar/'}
              fontIcon='bi-calendar2-range-fill'
              title={intl.formatMessage({id: 'MENU.CALENDAR_EVENTS'})}
            />
          )}
        </MenuInnerWithSub>
      )}
      {/* <MenuInnerWithSub
        title={intl.formatMessage({id: 'MENU.FDS_INTERNAL'})}
        to='/crafted'
        menuPlacement='bottom-start'
        menuTrigger='click'
      >
        <MenuItem to='/crafted/pages/profile/overview' fontIcon='bi-archive' title={intl.formatMessage({id: 'MENU.EMAIL_SCHEDULING'})} />
        <MenuItem to='/crafted/pages/profile/overview' fontIcon='bi-archive' title={intl.formatMessage({id: 'MENU.EMAIL_RECIPIENTS'})} />
        <MenuItem to='/crafted/pages/profile/overview' fontIcon='bi-archive' title={intl.formatMessage({id: 'MENU.MODULE_LICENSING'})} />
        <MenuItem to='/crafted/pages/profile/overview' fontIcon='bi-archive' title={intl.formatMessage({id: 'MENU.COMPANY_CREDENTIALS'})} />
        <MenuItem to='/crafted/pages/profile/overview' fontIcon='bi-archive' title={intl.formatMessage({id: 'MENU.COMPANY_CONFIGS'})} />
      </MenuInnerWithSub> */}
    </>
  )
}
